import { Link } from "react-router-dom";
import logo from "../assets/compass-logo.png";
import { SocialIcons } from "../components";
import { MobileMenu, Navigation } from ".";

export const Header = () => {
  return (
    <header>
      <Link to="/">
        <img
          src={logo}
          className="logo"
          alt="Compass Glass - Architectural Glazing and Glass Services"
        />
      </Link>
      <div className="nav-social-wrapper">
        <SocialIcons />
        <Navigation />
      </div>
      <MobileMenu />
    </header>
  );
};
